<template>
  <div class="two-col-images">
    <div class="section-header">
      <h3>{{ title }}</h3>
    </div>

    <div class="content">
      <div class="column">
        <div ref="col1Scroll" class="scroll-container">
          <div class="image-list" :style="{ height: col1ListHeight + 'px' }">
            <div v-for="(item, index) in [...col1, ...col1]" :key="'c1-' + index" class="image-item">
              <img :src="typeof item === 'string' ? item : item.image_url" class="image" />
              <span v-if="typeof item !== 'string' && item.name" class="image-name">{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <div class="column">
        <div ref="col2Scroll" class="scroll-container">
          <div class="image-list" :style="{ height: col2ListHeight + 'px' }">
            <div v-for="(item, index) in [...col2, ...col2]" :key="'c2-' + index" class="image-item">
              <img :src="typeof item === 'string' ? item : item.image_url" class="image" />
              <span v-if="typeof item !== 'string' && item.name" class="image-name">{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TwoColImages',
  props: {
    title: {
      type: String,
      default: ''
    },
    col1: {
      type: Array,
      default: () => []
    },
    col2: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      ITEM_HEIGHT: 100,
      imagesReady: false
    }
  },
  computed: {
    col1ListHeight() {
      return this.col1.length * 2 * this.ITEM_HEIGHT
    },
    col2ListHeight() {
      return this.col2.length * 2 * this.ITEM_HEIGHT
    }
  },
  watch: {
    col1() { this.preloadImages() },
    col2() { this.preloadImages() }
  },
  beforeDestroy() {
    if (this.col1Timer) clearInterval(this.col1Timer)
    if (this.col2Timer) clearInterval(this.col2Timer)
  },
  methods: {
    preloadImages() {
      this.imagesReady = false
      this.stopAllScroll()

      const col1Urls = this.col1.map(item => typeof item === 'string' ? item : item.image_url)
      const col2Urls = this.col2.map(item => typeof item === 'string' ? item : item.image_url)
      const allUrls = [...col1Urls, ...col2Urls]

      if (allUrls.length === 0) return

      const loadImage = (url) => {
        return new Promise((resolve) => {
          const img = new Image()
          img.onload = resolve
          img.onerror = resolve
          img.src = url
        })
      }

      Promise.all(allUrls.map(loadImage)).then(() => {
        this.imagesReady = true
        this.$nextTick(() => {
          this.startScroll('col1Scroll')
          this.startScroll('col2Scroll')
        })
      })
    },
    startAutoScroll() {
      if (this.imagesReady) {
        this.startScroll('col1Scroll')
        this.startScroll('col2Scroll')
      } else {
        this.preloadImages()
      }
    },
    stopAllScroll() {
      if (this.col1Timer) { clearInterval(this.col1Timer); this.col1Timer = null }
      if (this.col2Timer) { clearInterval(this.col2Timer); this.col2Timer = null }
    },
    startScroll(containerRef) {
      const container = this.$refs[containerRef]
      if (!container) return

      const scrollHeight = container.scrollHeight
      const clientHeight = container.clientHeight

      if (scrollHeight <= clientHeight) return

      const halfHeight = scrollHeight / 2
      let scrollTop = 0

      const scroll = () => {
        scrollTop += 1
        if (scrollTop >= halfHeight) {
          container.scrollTop = 0
          scrollTop = 0
        }
        container.scrollTop = scrollTop
      }

      if (this[`${containerRef}Timer`]) {
        clearInterval(this[`${containerRef}Timer`])
      }
      this[`${containerRef}Timer`] = setInterval(scroll, 30)
    }
  }
}
</script>

<style scoped>
.two-col-images {
  height: 100%;
  background: rgba(26, 54, 93, 0.6);
  border-radius: 12px;
  padding: 16px;
  border: 1px solid rgba(99, 179, 237, 0.2);
  display: flex;
  flex-direction: column;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(99, 179, 237, 0.2);
  flex-shrink: 0;
}

h3 {
  font-size: 14px;
  font-weight: 600;
  color: #e2e8f0;
  margin: 0;
}

.content {
  flex: 1;
  display: flex;
  gap: 12px;
  height: 0;
}

.column {
  /* flex: 1; */
  display: flex;
  flex-direction: column;
  /* height: 0;     */
  height: 100%;
  width: 50%;
}

.scroll-container {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
}

.scroll-container::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.image-list {
  padding: 4px 0;
}

.image-item {
  position: relative;
  margin-bottom: 8px;
}

.image-item:not(:last-child)::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: #fff;
}

.image {
  width: 100%;
  height: auto;
  border-radius: 6px;
  display: block;
}

.image-name {
  display: block;
  font-size: 12px;
  color: #a0aec0;
  padding: 4px 0;
  text-align: center;
}
</style>